/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface QuestionOption {
  /** The option code as authored in the IG */
  value: string;
  label: string;
  /** Contribution to a sum. None for an option that does not score */
  weight?: number | null;
}
